<div class="cxone-custom-data-import-view-container cx-one-ui">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>
    <div id="header">
        <div id="feedName-div">
            <button cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Import_Data" class="btn btn-link"
                id="import-data-label" (click)="handleBackBtnClick()">
                Import Data</button>
            <h5 id="feed-info">{{feedName}} | {{importID}}</h5>
        </div>
        <div id="back-btn-div">
            <button cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Back_Button" id="btn-back"
                class="cxone-btn btn-big btn-secondary btn-bg-is-white" (click)="handleBackBtnClick()"
                tabindex="0">Back</button>
        </div>
    </div>
    <div>
        <cxone-omnibar id="omnibar-container" [itemCountLabel]="userCountLabel" [isFilterable]="false"
            [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="userSearchQueryChange($event)"
            [selectedItemCountLabel]="selectedItemCountLabel" [searchQuery]="searchInput">
            <span cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="ETL_Selected"
                id="selected">selected</span>
            <cxone-omnibar-custom-content class="custom-content" id="ETL-omnibar-content">
                <div id="delete-btn-div" *ngIf="showDeleteBtn">
                    <button cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Delete"
                        class="cxone-btn btn-big btn-secondary btn-bg-is-white" [disabled]="btnDisabled || showSpinner" id="delete-btn"
                        (click)="deleteBtnClick()">Delete</button>
                </div>
            </cxone-omnibar-custom-content>
        </cxone-omnibar>
        <cxone-grid [columnDefs]="columnNames" [gridOptions]="gridOptions" [rowData]="filteredUserGridData"
            id="ETL-grid">
        </cxone-grid>
    </div>
</div>